export const pathsToFetchNotifications = [ 'record-calendars', 'record-lists' ];
